var getDisplayName = function getDisplayName(ReactComponent) {
  var defaultName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Component';

  if (!ReactComponent) {
    return defaultName;
  }

  return ReactComponent.displayName || ReactComponent.name || defaultName;
};

export default getDisplayName;